import angular from 'angular';

import uiRouter from 'angular-ui-router';
import BgvTrackerComponent from './bgvTracker.component';
import routing from './bgvTracker.routes';

export default angular
  .module('verifyApp.bgvtracker', [uiRouter])
  .config(routing)
  .component('bgvtracker', BgvTrackerComponent)
  .name;



// WEBPACK FOOTER //
// ./client/app/reports/bgvTracker/index.js